module.exports = __webpack_public_path__ + "static/media/list-plus.970bfafc.svg";